var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
 * Writes the selection from the Add Pass button to the collection of Weld Passes.
 *
 * @function evalute - evaluate ucbWeldPassTypeSelectBehavior
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel;
  const _Object$keys = Object.keys(selection),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    key = _Object$keys2[0];
  if (key === undefined) {
    return;
  }
  const targetContentPath = appendPath('/weldPasses', key);
  const writeSource = {
    type: 'writeContentBehavior',
    targetContentPath,
    source: selection[key]
  };
  await sourceEvaluator(writeSource);
};
module.exports = {
  evaluate
};